import CompLayout from "@/pcomponents/comp/layout/layout";
import TextbookStuUseListArea from "@/pages/comp/book_order/comp_textbook/common/stu_use_list";
import { useLocation } from "react-router";

function TextBookStuUseListPage() {
  const { state } = useLocation();
  let s_subject="";
  if(state && state.s_subject){
    s_subject=state.s_subject;
  }

  return (
    <CompLayout isConTitle={false}>
      <TextbookStuUseListArea
        s_subject={s_subject}
      ></TextbookStuUseListArea>
    </CompLayout>
  );
};
export default TextBookStuUseListPage;